export default "__VITE_ASSET__CeOMCLTM__"